import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {MatChipInputEvent} from '@angular/material/chips';
import { ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { TranslateService } from '@ngx-translate/core';
import { StateService } from 'src/app/state.service';
import { FilterDictionary } from './filter-dictionary';


@Component({
  selector: 'app-table-search',
  templateUrl: './table-search.component.html',
  styleUrls: ['./table-search.component.css']
})

export class TableSearchComponent implements OnInit {
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER];
  fieldCtrl = new FormControl();
  filteredFields: Observable<string[]>;

  @Input()
  allFields: string[] = [];
    
  filters: FilterDictionary[] = [];
  
  @Output() filterChangedEmitter = new EventEmitter<FilterDictionary[]>();
  
  @ViewChild('filterInput') filterInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  translations: string[] = [];

  currentValue: string = '';

  largeScreen: boolean = false;
  currentScreenSideSubscription: Subscription;

  constructor(public translate: TranslateService, public stateService: StateService) {
        
    this.translate.get(['table-search.search', 'table-search.search-in', 'table-search.contains' ]).subscribe((translations: string[]) => {
      this.translations = translations;
    });

    //dropdown fields 
    this.filteredFields = this.fieldCtrl.valueChanges.pipe(
        startWith(null),
        map((field: string | null) => field ? this._filter(field) : this.currentValue.length > 0 ? this.allFields.slice() : []));  
  }
  ngOnInit(): void {

    this.currentScreenSideSubscription = this.stateService.currentScreenSize$.subscribe((screenSize) => {
      this.largeScreen = screenSize;
    });

  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    if (event.value.trim().length > 0)
        this.currentValue = event.value.trim();

    // Reset the input value
    if (input) {
      input.value = '';
    }
    //to trigger open dropdown
    this.fieldCtrl.setValue(null);   
  }

  addChip(field: string, filterValue: string): void {
    
    if ((filterValue || '').trim().length > 0) {
      this.filters.push({ field: field, value: filterValue.trim() });
      this.filterChangedEmitter.emit(this.filters);
    }    
    this.currentValue = '';
  }

  remove(field: string): void {
    let i = 0;
    for (let filter of this.filters)
    {
      if (filter.field === field)
        this.filters.splice(i, 1);
      i++;
    }  
    this.filterChangedEmitter.emit(this.filters);

  }

  selected(event: MatAutocompleteSelectedEvent): void {

    event.option.deselect();
    if (this.currentValue && this.currentValue.length > 0)
    {
      this.addChip(event.option.value, this.currentValue);
    }
           
    this.filterInput.nativeElement.value = '';
    this.fieldCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allFields.filter(field => field.toLowerCase().indexOf(filterValue) === 0);
  }  

  setOptionValue(field: string)
  {
    return (field === '' ? '' : this.translations['table-search.search-in'] + field) + (field === '' ? this.translations['table-search.contains'] : ' for ' ) +  '"' + this.currentValue + '"' ;
  }

}




